// Import your application, and register all stimulus controllers here.
// Keep controllers in alphabetical order.

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import ClearableController from "./clearable_controller"
application.register("clearable", ClearableController)

import ClubVideoController from "./club_video_controller.js"
application.register("club-video", ClubVideoController)

import ConfirmableController from "./confirmable_controller"
application.register("confirmable", ConfirmableController)

import DebouncedSearchController from "./debounced_search_controller"
application.register("debounced-search", DebouncedSearchController)

import DismissableController from "./dismissable_controller"
application.register("dismissable", DismissableController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import LanguageDropdownController from "./language_dropdown_controller"
application.register("language-dropdown", LanguageDropdownController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import VideoUploadController from "./video_upload_controller"
application.register("video-upload", VideoUploadController)

import TemplatableController from "./templatable_controller"
application.register("templatable", TemplatableController)